module.exports = __webpack_public_path__ + "img/Dateold.75fcc5c8.svg";